import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import token from './modules/token'
import user from './modules/user'
import pages from './modules/pages'
import cti from './modules/cti'
import identity from './modules/identity'
import announcements from './modules/announcements'
import queueAdditional from './modules/queueAdditional'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    token,
    user,
    pages,
    cti,
    identity,
    announcements,
    queueAdditional
  },
  strict: process.env.NODE_ENV !== 'production'
})
